import '.ag{position:relative;}.ssr-plugin'
import '.ju{width:64px;}.ssr-plugin'
import '.jv{height:64px;}.ssr-plugin'
import '.aj{flex-shrink:0;}.ssr-plugin'
import '.br{position:absolute;}.ssr-plugin'
import '.jw{bottom:-4px;}.ssr-plugin'
import '.hx{right:-4px;}.ssr-plugin'
import '.fh{border-radius:50%;}.ssr-plugin'
import '.ce{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ax{overflow:hidden;}.ssr-plugin'
import '.jx{width:32px;}.ssr-plugin'
import '.jy{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ag ju jv aj"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="br jw hx fh ce ax jx jy"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
